export default __webpack_public_path__ + "static/media/shubhamresume.fbc45575.pdf";